// extracted by mini-css-extract-plugin
export default {"hideTooltip":"S--z","fadeIn":"T--z","delay":"U--z","recommendedSizeTooltip":"V--z"};